module.exports = __webpack_public_path__ + "img/kefu.9b0bfa9f.png";